// ROUTES
import VueRouter from "vue-router";
import store from "./store";
const { resolveLayoutForPath } = require('../../../../shared/routeMatcher');
// const form = require("../components/layouts/form.vue").default;

const edit2DiagStartedAt = typeof performance !== 'undefined' ? performance.now() : 0;

function sendEdit2BootDiag(stage, details = {}) {
  if (typeof window === 'undefined' || new URLSearchParams(window.location.search).get('_bfEdit2Diag') !== '1') return;
  try {
    window.parent.postMessage(JSON.stringify({
      __bfEdit2Diag: true,
      stage,
      elapsedMs: typeof performance !== 'undefined' ? Math.round(performance.now() - edit2DiagStartedAt) : 0,
      details
    }), '*');
  } catch (e) {
    return;
  }
}

let routes = []

const router = new VueRouter({
  mode: "hash", // Keep hash mode for offline/PWA support
  routes
});

router.beforeEach((to, from, next) => {
  if (!store.state.site.loaded) {
    sendEdit2BootDiag('boot:route:site-load-dispatch', {
      siteLoaded: store.state.site.loaded,
      stateOnline: store.state.site.isOnline
    });
    store.dispatch("LOAD_SITE_MODEL", {})
    .then((res) => {
      sendEdit2BootDiag('boot:route:site-load-resolved', {
        hasLayouts: Boolean(res && res.content && res.content.layouts)
      });
      const formComp = require("../components/layouts/form.vue").default
      let slugs = Object.assign({}, res.content.layouts),
          newRoutes = [],
          hasErrorPage = false;
          
      for (const [key, value] of Object.entries(slugs)) {
        key === 'error' ? hasErrorPage = true : null;
        newRoutes.push(
          Object.assign({
            path: `/${key}`,
            component: formComp,
            props: {
              urnSlug: key
            }
          }, value)
        )
      }
      newRoutes.push({
        path: "/form/:id",
        component: require("../components/layouts/form.vue").default,
        props: true,
        name: "slug"
      })
      
      if (!hasErrorPage) {
        newRoutes.push(
            Object.assign({
              path: '/error',
              component: formComp,
              props: {
                urnSlug: 'error'
              }
            }, {value : {id: 'FR_errorpage'}})
          );
          Object.assign(res.content.layouts, {error: {id: 'FR_errorpage'}});
      }

      newRoutes.push({
        //  since previous catches slugs, this catches naked domain '/' ,
        path: "/",
        component: require("../components/layouts/form.vue").default,
        props: { urnSlug: "default" }
      })

      routes = newRoutes
      
      routes.forEach((route) => router.addRoute(route));

      sendEdit2BootDiag('boot:route:next', { routeCount: routes.length });
      next(to);
    })
    .catch(error => {
      sendEdit2BootDiag('boot:route:site-load-error', {
        name: error && error.name || typeof error,
        code: error && error.code || null,
        className: error && error.className || null,
        stateOnline: store.state.site.isOnline,
        siteLoaded: store.state.site.loaded
      });
      console.log('@routes error: ', error);
      if (error.code == 404) BF.errorThrow(10050, `No site record found for: ${window.location.host}`, 'Site Not Found.');
      else BF.errorThrow(error)
    });
  }
  else {
    // check for navigation guards
    //checking if slug exists
    if ((to.path && to.path !== '/') && !(to.path.startsWith('/form/'))) {
      const routeMatch = resolveLayoutForPath(store.state.site.content.layouts, to.path);
      const slug = to.path.replace(/^\/|\/$/g, "");

      if (!routeMatch) BF.errorThrow(404, `Page not found for slug: ${slug}`, 'Path Not Found.');
    }
    next();
  }
});

router.beforeResolve((to, from, next) => {
  let layouts = store.state.site.content.layouts;
  let path = to.path.replace(/^\/|\/$/g, ""); // remove slash's
  let pathNolast = path.replace(/\/([^/]*)$/g, ""); // remove slash's
  let layout = layouts[path] || layouts[pathNolast];

  let needsAuth = false;
  to.matched.forEach(function(record) {
    if (typeof record.meta.requiresAuth !== "undefined") {
      needsAuth = record.meta.requiresAuth;
    }
  });

  store.dispatch("NO_AUTH").then(res => {
    next();
  });

});
export default router;
